import { SVGProps, Ref, forwardRef } from 'react';

export const LinkedinSolidSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23 2.604v18.792A1.604 1.604 0 0 1 21.396 23H2.604A1.604 1.604 0 0 1 1 21.396V2.604A1.604 1.604 0 0 1 2.604 1h18.792A1.604 1.604 0 0 1 23 2.604m-7.173 6.417c1.843 0 3.965 1.246 3.965 4.455v6.316h-3.209V14.25c0-1.695-.94-2.401-1.856-2.401-1.118 0-2.269.751-2.269 2.443v5.5H9.25V9.25h3.025v1.49h.041c.303-.647 1.669-1.72 3.511-1.72m-8.41.229H4.208v10.542h3.209zm-.03-4.485c.203.311.31.676.305 1.048v.068a1.833 1.833 0 0 1-1.88 1.788H5.79a1.88 1.88 0 1 1 1.598-2.904"
                fill="currentColor"
            />
        </g>
    </svg>
));
LinkedinSolidSize24Glyph.displayName = 'LinkedinSolidSize24Glyph';
